import { Color } from "./Color";

export { Color, Opacity } from "./Color";
export type { ColorKey, ColorOrKey, ColorsOrKeys } from "./Color";
export default Color;
